<template>
  <div class="layoutDefault" style="margin-top: 2rem">
    <div class="z-10 mx-auto" style="max-width: 746px">
      <div
        class="flex cursor-pointer rounded-lg py-2"
        style="max-width: 200px"
        @click="$router.go(-1)"
      >
        <IconArrow class="mr-3 mt-1 stroke-current text-habu h-6 w-6 stroke-2 transform rotate-0" />
        <span class="text-2xl text-normal">News</span>
      </div>
    </div>

    <div style="max-width: 746px" class="mx-auto mt-6 flex-col gap-6 relative z-10">
      <div class="h-sosmed-card">
        <div class="flex items-center justify-between space-x-2 px-5 pt-2">
          <div class="flex items-center overflow-x-auto" v-if="!$route.query.is_highlight">
            <div
              v-for="c in categories"
              :key="c.id"
              class="px-7 pt-3 pb-2 font-Roboto cursor-pointer hover:bg-gray-100 hover:text-gray-700 rounded-t whitespace-nowrap"
              :class="
                c.id == category
                  ? 'border-gray-500 border-b-4 text-gray-600'
                  : 'border-b border-gray-200 text-gray-500'
              "
              @click="category = c.id"
            >
              {{ c.name }}
            </div>
          </div>

          <button
            @click="setHighlight"
            class="capitalize px-2.5 py-1 hover:bg-transparent text-sm hover:text-gray-800 rounded-lg font-medium ml-auto w-fit"
            :class="
              $route.query.is_highlight
                ? 'bg-blue-500 text-white mt-2.5'
                : 'bg-gray-100 text-gray-500'
            "
          >
            Highlight
          </button>
        </div>

        <div class="mt-2 flex flex-col px-4 pb-5">
          <div
            class="p-5 border-b border-gray-100 hover:bg-gray-100 rounded-lg"
            v-for="item in news"
            :key="item.id"
          >
            <div
              v-html="item.description"
              class="line-clamp-2 cursor-pointer [&_iframe]:hidden [&_img]:hidden"
              @click="MODAL_NEWS(item)"
            ></div>
            <div v-if="item.file_url.length" class="mt-2 rounded">
              <img
                v-if="item.file_url[0].file_type == 'image'"
                :src="item.file_url[0].file_path"
                class="rounded-lg cursor-pointer"
                @click="MODAL_NEWS(item)"
              />
              <video v-else :src="item.file_url[0].file_path" controls class="rounded-lg"></video>
            </div>
            <div class="flex items-center justify-between space-x-1 mt-2.5">
              <div class="flex items-center space-x-5">
                <div class="flex items-center space-x-2 cursor-pointer" @click="toLiked(item.id)">
                  <IconLike
                    class="h-6 w-6"
                    :class="item.is_like ? 'text-blue-500' : 'text-gray-400'"
                  />
                  <span class="text-gray-600 font-medium">{{ item.likes_count }}</span>
                </div>
                <div class="flex items-center space-x-2 cursor-pointer" @click="MODAL_NEWS(item)">
                  <IconComment class="h-6 w-6 text-gray-400" />
                  <span class="text-gray-600 font-medium">{{ item.comments_count }}</span>
                </div>
              </div>

              <div
                class="flex items-center space-x-3 overflow-x-auto cursor-pointer w-full justify-end"
                @click="MODAL_NEWS(item)"
              >
                <div class="text-gray-600 font-medium">
                  {{ item.published_at | moment('DD MMM YYYY') }}
                </div>
                <div class="rounded px-1.5 py-0.5 font-medium bg-gray-100 text-gray-600">
                  {{ item.category_name }}
                </div>
              </div>
            </div>
          </div>

          <button
            v-if="news.length > 0 && page < lastPage"
            @click="loadMore"
            :disabled="loading"
            class="mx-auto my-5 rounded-lg border border-gray-100 py-2 px-3 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-600"
          >
            Load more
          </button>

          <div v-if="!news.length" class="mx-auto flex flex-col my-5">
            <IconNonews class="h-20 w-24 mx-auto" />
            <span class="text-center text-gray-600 font-Roboto">Check back later for updates</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconComment from '@/assets/icons/icon-comment.svg?inline'
import IconLike from '@/assets/icons/icon-like.svg?inline'
import IconNonews from '@/assets/icons/icon-nonews.svg?inline'
import IconArrow from '@/assets/icons/icon-arrow.svg?inline'
import { sosmedCategoryIndex, sosmedPostIndex, sosmedPostLiked } from '@/services/apiSosmed'
import { mapActions } from 'vuex'

export default {
  name: 'NewsIndex',
  components: {
    IconComment,
    IconLike,
    IconNonews,
    IconArrow
  },
  data() {
    return {
      categories: [
        {
          id: 0,
          name: 'All'
        }
      ],
      news: [],
      page: 1,
      lastPage: 1,
      category: 0,
      loading: false
    }
  },
  watch: {
    category: function () {
      this.page = 1
      this.getNews({
        category_id: this.category,
        per_page: 10,
        is_highlight: this.$route.query.is_highlight || 0
      })
    }
  },
  mounted() {
    this.getCategories()
    this.getNews({ per_page: 10, is_highlight: this.$route.query.is_highlight || 0 })
  },
  methods: {
    ...mapActions('modal', ['MODAL_NEWS']),
    async getCategories() {
      const res = await sosmedCategoryIndex()
      if (res) {
        this.categories = [...this.categories, ...res.data]
      }
    },
    async getNews(params) {
      this.loading = true
      let res = await sosmedPostIndex(params)
      if (res) {
        this.news = res.data
        this.lastPage = res.meta.last_page
      }
      this.loading = false
    },
    async loadMore() {
      this.loading = true
      this.page++
      let params = {
        page: this.page,
        category_id: this.category,
        per_page: 10,
        is_highlight: this.$route.query.is_highlight || 0
      }

      let res = await sosmedPostIndex(params)

      if (res) {
        this.news = [...this.news, ...res.data]
        this.lastPage = res.meta.last_page || 1
      }
      this.loading = false
    },
    async toLiked(id) {
      if (this.countLike) return

      this.countLike = 1

      let res = await sosmedPostLiked({
        post_id: id
      })

      if (res) {
        this.news = this.news.map(news => {
          if (news.id === id) {
            news.is_like = res.data.is_like == false ? 0 : 1
            news.likes_count =
              res.data.is_like == false ? news.likes_count - 1 : news.likes_count + 1
          }
          return news
        })
      }

      setTimeout(() => {
        this.countLike = 0
      }, 3000)
    },
    setHighlight() {
      if (this.$route.query.is_highlight) {
        this.getNews({ per_page: 10, is_highlight: '' })

        this.$router.replace({
          query: { ...this.$route.query, is_highlight: '', t: new Date().getTime() }
        })
      } else {
        this.getNews({ per_page: 10, is_highlight: '1' })
        this.$router.replace({
          query: { ...this.$route.query, is_highlight: 1, t: new Date().getTime() }
        })
      }
    }
  }
}
</script>
